import React from "react"
import Img from "gatsby-image"
import { ImgItem } from "./image-item"

const AboutActs = ({ image }) => {
  return (
    <ImgItem>
      <div className="textWrapper">
        <h1>Show Stops</h1>

        <p1>
          Nobody ever wants a show stop, but if you do, you'll be glad you're
          running Show StopWatch. Simply press the Show Stop button in the top
          left and we'll show you the time it was stopped and the elapsed time.
          Hit resume when you're ready to continue and we'll calculate
          everything else.
        </p1>
      </div>

      <Img fluid={image.childImageSharp.fluid} alt="Image" className="image" />
    </ImgItem>
  )
}

export default AboutActs
